var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mask overlay-fade" }, [
    _c("div", { staticClass: "bg-white flex flex-column tutorial-frame" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/img/tutorial/import_tutorial_back.png"),
          alt: "import_tutorial",
        },
      }),
      _c("div", [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.isNovelCreated
                  ? _vm.$t("homePage.importTutorial.titleWithWork")
                  : _vm.$t("homePage.importTutorial.titleNoWork")
              ) +
              " "
          ),
        ]),
        _c("div", { staticClass: "content" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.isNovelCreated
                  ? _vm.$t("homePage.importTutorial.contentPrefixWithWork")
                  : _vm.$t("homePage.importTutorial.contentPrefixNoWork")
              )
          ),
          _c("span", { staticClass: "yellow" }, [
            _vm._v(_vm._s(_vm.$t("homePage.importTutorial.contentHighlight"))),
          ]),
          _vm._v(_vm._s(_vm.$t("homePage.importTutorial.contentSuffix")) + " "),
        ]),
        _c("div", { staticClass: "import" }, [
          _c(
            "button",
            { staticClass: "import-button", on: { click: _vm.importClicked } },
            [_vm._v(_vm._s(_vm.$t("homePage.importTutorial.importButton")))]
          ),
        ]),
        _c("div", { staticClass: "skip", on: { click: _vm.skipClicked } }, [
          _vm._v(_vm._s(_vm.$t("homePage.importTutorial.skip"))),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }